/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdApplicationNotificationsScheduledNotificationItem } from './FxIdApplicationNotificationsScheduledNotificationItem';
import {
    FxIdApplicationNotificationsScheduledNotificationItemFromJSON,
    FxIdApplicationNotificationsScheduledNotificationItemFromJSONTyped,
    FxIdApplicationNotificationsScheduledNotificationItemToJSON,
    FxIdApplicationNotificationsScheduledNotificationItemToJSONTyped,
} from './FxIdApplicationNotificationsScheduledNotificationItem';

/**
 * Аргументы для атомарной замены всех pending-уведомлений пользователя
 * @export
 * @interface FxIdApplicationNotificationsReplaceReplaceScheduledNotificationsArgs
 */
export interface FxIdApplicationNotificationsReplaceReplaceScheduledNotificationsArgs {
    /**
     * Игра, от имени которой заменяются уведомления
     * @type {string}
     * @memberof FxIdApplicationNotificationsReplaceReplaceScheduledNotificationsArgs
     */
    Game: string;
    /**
     * Новый набор уведомлений (заменяет все существующие pending)
     * @type {Array<FxIdApplicationNotificationsScheduledNotificationItem>}
     * @memberof FxIdApplicationNotificationsReplaceReplaceScheduledNotificationsArgs
     */
    Notifications: Array<FxIdApplicationNotificationsScheduledNotificationItem>;
}

/**
 * Check if a given object implements the FxIdApplicationNotificationsReplaceReplaceScheduledNotificationsArgs interface.
 */
export function instanceOfFxIdApplicationNotificationsReplaceReplaceScheduledNotificationsArgs(value: object): value is FxIdApplicationNotificationsReplaceReplaceScheduledNotificationsArgs {
    if (!('Game' in value) || value['Game'] === undefined) return false;
    if (!('Notifications' in value) || value['Notifications'] === undefined) return false;
    return true;
}

export function FxIdApplicationNotificationsReplaceReplaceScheduledNotificationsArgsFromJSON(json: any): FxIdApplicationNotificationsReplaceReplaceScheduledNotificationsArgs {
    return FxIdApplicationNotificationsReplaceReplaceScheduledNotificationsArgsFromJSONTyped(json, false);
}

export function FxIdApplicationNotificationsReplaceReplaceScheduledNotificationsArgsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationNotificationsReplaceReplaceScheduledNotificationsArgs {
    if (json == null) {
        return json;
    }
    return {
        
        'Game': json['Game'],
        'Notifications': ((json['Notifications'] as Array<any>).map(FxIdApplicationNotificationsScheduledNotificationItemFromJSON)),
    };
}

export function FxIdApplicationNotificationsReplaceReplaceScheduledNotificationsArgsToJSON(json: any): FxIdApplicationNotificationsReplaceReplaceScheduledNotificationsArgs {
    return FxIdApplicationNotificationsReplaceReplaceScheduledNotificationsArgsToJSONTyped(json, false);
}

export function FxIdApplicationNotificationsReplaceReplaceScheduledNotificationsArgsToJSONTyped(value?: FxIdApplicationNotificationsReplaceReplaceScheduledNotificationsArgs | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Game': value['Game'],
        'Notifications': ((value['Notifications'] as Array<any>).map(FxIdApplicationNotificationsScheduledNotificationItemToJSON)),
    };
}

